import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";

const getClubList = async () => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/club-list", {}, headerConfig);
        return response;
};


const getClubLastPaymentDetail = async (data) => {
    console.log('data',data);
    const response = await axios
        .post(BASE_API_URL + "affiliation/club-last-payment", data, headerConfig);
        return response;
};

const generateClubPaymentYears = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/generate-payment-year", data, headerConfig);
        return response;
};


const saveClubAffiliation = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/affiliation-fee-action", data, headerConfig);
        return response;
};

const clubReceiptList = async () => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/club-receipt-list", {}, headerConfig);
        return response;
};

const clubYearDataList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/receipt-year-data", data, headerConfig);
        return response;
};

const clubYearList = async () => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/year-list", {}, headerConfig);
        return response;
};

const clubFeeHistoryReport = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "affiliation/affiliation-fee-history", data, headerConfig);
        return response;
};


const clubService = {
    getClubList,
    getClubLastPaymentDetail,
    generateClubPaymentYears,
    saveClubAffiliation,
    clubReceiptList,
    clubYearDataList,
    clubYearList,
    clubFeeHistoryReport
};

export default clubService;